__turbopack_context__.v({
  "dropdownGroup": "Calendar-module__tqk-LG__dropdownGroup",
  "dropdownSelect": "Calendar-module__tqk-LG__dropdownSelect",
  "header": "Calendar-module__tqk-LG__header",
  "react-aria-Calendar": "Calendar-module__tqk-LG__react-aria-Calendar",
  "react-aria-CalendarCell": "Calendar-module__tqk-LG__react-aria-CalendarCell",
  "react-aria-CalendarGrid": "Calendar-module__tqk-LG__react-aria-CalendarGrid",
  "react-aria-CalendarGridBody": "Calendar-module__tqk-LG__react-aria-CalendarGridBody",
  "react-aria-CalendarHeaderCell": "Calendar-module__tqk-LG__react-aria-CalendarHeaderCell",
});
